import { createRouteRef } from '@backstage/frontend-plugin-api';

export const rootRouteRef = createRouteRef();

export const graphEngineDetailsRouteRef = createRouteRef({
  params: ['graphEngineId'],
});
